import React from "react";
import { useProposalContext } from "../../../../hooks/useProposalContext";
import "./ProposalIndicator.scss";

function ProposalIndicator() {
	const { currentProposal } = useProposalContext();
	return (<span className="proposal-indicator">{currentProposal?.items?.length}</span>);
}

export default ProposalIndicator;
